<cjm-content [loading]="spotlightItemsLoading">
	@if (spotlightItems?.associations?.length > 0 || spotlightItems?.products?.length > 0) {
		<cjm-layout-container layoutType="full-width" preventSpacing="bottom">
			<ng-container main>
				<h2 class="c-vloket-header c-vloket-header--h2" cypressTag="General.Header.H2">
					<span class="c-vloket-text-marking c-vloket-text-marking--line-through">
						{{ i18nKeys.Home.InTheSpotlight.Title | translate }}
					</span>
				</h2>
			</ng-container>
		</cjm-layout-container>
	}
	@if (spotlightItems?.associations?.length > 0 || spotlightItems?.products?.length > 0) {
		<cjm-layout-container
			class="c-in-the-spotlight-section__associations-and-products"
			classesMain="c-in-the-spotlight-section__main"
			classesAside="c-in-the-spotlight-section__aside"
			layoutType="split-equal"
			asidePosition="right"
			preventSpacing="top"
		>
			@if (spotlightItems?.associations?.length > 0) {
				<ng-container main>
					@for (association of spotlightItems.associations; track association) {
						<vloket-association-card
							cypressTag="InTheSpotlightSection.AssociationCard"
							[association]="association"
							[withLink]="true"
							[link]="[appRoutePaths.Associations, association.associationNumber]"
						/>
					}
				</ng-container>
			}
			@if (spotlightItems?.products?.length > 0) {
				<ng-container asideRight>
					@for (product of spotlightItems?.products; track product) {
						<vloket-product-grid-item
							cypressTag="InTheSpotlightSection.ProductCard"
							[product]="product"
							[hasFavouriteButton]="true"
							[actionInProgress]="settingProductAsFavorite"
							(setItemAsFavoriteClicked)="setItemAsFavoriteClicked.emit(product.id)"
							(removeItemAsFavoriteClicked)="removeItemAsFavoriteClicked.emit(product.id)"
						/>
					}
				</ng-container>
			}
		</cjm-layout-container>
	}
</cjm-content>

@if (advicePages.length > 0) {
	<cjm-layout-container
		class="c-in-the-spotlight-section__advice-container"
		layoutType="full-width"
		preventSpacing="top"
	>
		<cjm-content class="c-in-the-spotlight-section__advice-pages" main [loading]="adviceLoading">
			<h2 class="c-vloket-header c-vloket-header--h2" cypressTag="General.Header.H2">
				<span class="c-vloket-text-marking c-vloket-text-marking--line-through">
					{{ i18nKeys.Home.AdviceForAssociations.Title | translate }}
				</span>
			</h2>
			<p>
				{{ i18nKeys.Home.AdviceForAssociations.Text | translate }}
			</p>
			<cjm-link
				[classes]="'c-home-header__link c-home-header__block-link'"
				[to]="[appRoutePaths.Advice]"
				[noDecoration]="true"
				[title]="i18nKeys.Home.AdviceForAssociations.MoreAdviceButton.Title | translate"
				[icon]="{
					icon: 'fa-chevron-right',
					type: 'fa-solid',
					position: 'right'
				}"
			>
				<span>{{ i18nKeys.Home.AdviceForAssociations.MoreAdviceButton.Text | translate }}</span>
			</cjm-link>
			<div class="c-in-the-spotlight-section__advice-pages__pages">
				@for (page of advicePages; track page) {
					<vloket-advice-card [page]="page" />
				}
			</div>
		</cjm-content>
	</cjm-layout-container>
}
